import { Injectable } from '@angular/core';
import { System } from '../../shared-components/System';

import { YearService } from '../../shared-components/year/year.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { StudentCourseRequestDTO, OverallRequirement, CourseRequestSchoolPolicyDTO, SchoolPoliciesCR360ParentStudentViewDTO, CRRequirementCourses, CRLookupDTO, GradeLevelRequirements, StudentCourseRequestPreferredTeachers } from './student-course-request.model';


@Injectable({
  providedIn: 'root'
})
export class StudentCourseRequestService {
  GetConflictsForStudentPortal(studentId: number, SiteYearId: number, toAddCourses: number[], toDeleteCourses: number[], toKeepCourses: number[], toUpdateCourses: number[]) {
    const data = [toAddCourses, toDeleteCourses, toKeepCourses, toUpdateCourses];
    let queryString = '';
    queryString = '?studentId=' + studentId +
      '&siteYearId=' + SiteYearId;
    return this.http.post<string[]>(System.apiURL.Counselor + 'GetConflictsForStudentPortal' + queryString, data) ;
  }

  constructor(private http: HttpClient, private yearService: YearService) { }

  getStudentCourseRequest(studentId, siteId, yearId, gradeLevelId): Observable<GradeLevelRequirements[]> {
    let queryString = '';
    queryString += '?studentId=' + studentId +
      '&siteId=' + siteId +
      '&yearId=' + yearId +
      '&gradeLevelId=' + gradeLevelId;
    return this.http.get<GradeLevelRequirements[]>(System.apiURL.Counselor + 'GetStudentCourseRequest' + queryString);
  }

  getCourseRequestOverAllRequirements(studentId, siteId, yearId, gradeLevelId): Observable<OverallRequirement> {
    let queryString = '';
    queryString += '?studentId=' + studentId +
      '&siteId=' + siteId +
      '&yearId=' + yearId +
      '&gradeLevelId=' + gradeLevelId;
    return this.http.get<OverallRequirement>(System.apiURL.Counselor + 'GetCourseRequestOverAllRequirements' + queryString);
  }

  saveCourseRequestData(studentId, siteId, yearId, gradeLevelId, data: StudentCourseRequestDTO[]): Observable<boolean> {
    let queryString = '';
    queryString += '?studentId=' + studentId +
      '&siteId=' + siteId +
      '&yearId=' + yearId +
      '&gradeLevelId=' + gradeLevelId;
    return this.http.post<boolean>(System.apiURL.Counselor + 'AddEditStudentCourseRequests' + queryString, data);
  }

  deleteStudentCourseRequest(studentCourseRequestId: number): Observable<boolean> {
    let queryString = '';
    queryString += '?studentCourseRequestId=' + studentCourseRequestId;
    return this.http.get<boolean>(System.apiURL.Counselor + 'DeleteStudentCourseRequests' + queryString);
  }

  getCourseRequestSchoolPolicy(siteId, yearId): Observable<CourseRequestSchoolPolicyDTO> {
    let queryString = '';
    queryString += '?siteId=' + siteId +
      '&yearId=' + yearId;
    return this.http.get<CourseRequestSchoolPolicyDTO>(System.apiURL.Counselor + 'GetCourseRequestSchoolPolicy' + queryString);
  }

  getCourseRequestStudent360SchoolPolicy(siteId, yearId): Observable<SchoolPoliciesCR360ParentStudentViewDTO> {
    let queryString = '';
    queryString += '?siteId=' + siteId +
      '&yearId=' + yearId;
    return this.http.get<SchoolPoliciesCR360ParentStudentViewDTO>(System.apiURL.Counselor + 'GetCourseRequestStudent360SchoolPolicy' + queryString);
  }

  getCRCourses(studentId, siteId, yearId, gradeLevelId): Observable<CRRequirementCourses[]> {
    let queryString = '';
    queryString += '?studentId=' + studentId +
      '&siteId=' + siteId +
      '&yearId=' + yearId +
      '&gradeLevelId=' + gradeLevelId;
    return this.http.get<CRRequirementCourses[]>(System.apiURL.Counselor + 'GetCRRequirementCourses' + queryString);
  }
  getCRPeriods(siteId, yearId, gradeLevelId, studentId): Observable<CRLookupDTO[]> {
    let queryString = '';
    queryString += '?siteId=' + siteId +
      '&yearId=' + yearId +
      '&gradeLevelId=' + gradeLevelId +
      '&studentId=' + studentId;
    return this.http.get<CRLookupDTO[]>(System.apiURL.Counselor + 'GetCRRequirementPeriods' + queryString);
  }
  getCRTerms(siteId, yearId, gradeLevelId, studentId): Observable<CRLookupDTO[]> {
    let queryString = '';
    queryString += '?siteId=' + siteId +
      '&yearId=' + yearId +
      '&gradeLevelId=' + gradeLevelId +
      '&studentId=' + studentId;
    return this.http.get<CRLookupDTO[]>(System.apiURL.Counselor + 'GetCRRequirementTerms' + queryString);
  }
  getCRTeachers(siteId, yearId, gradeLevelId, studentId): Observable<CRLookupDTO[]> {
    let queryString = '';
    queryString += '?siteId=' + siteId +
      '&yearId=' + yearId +
      '&gradeLevelId=' + gradeLevelId +
      '&studentId=' + studentId;
    return this.http.get<CRLookupDTO[]>(System.apiURL.Counselor + 'GetCRRequirementTeachers' + queryString);
  }

  getStudentCourseRequestPreferredTeachers(student_ID: number, siteYear_ID: number): Observable<StudentCourseRequestPreferredTeachers[]> {
    const queryString = `?student_ID=${student_ID}&siteYear_ID=${siteYear_ID}`;
    return this.http.get<StudentCourseRequestPreferredTeachers[]>(System.apiURL.Counselor + 'GetStudentCourseRequestPreferredTeachers' + queryString);

  }

  massAddRequiredCourseRequests(siteYearId: number, studentIds: number[]) {
    const queryString = '?siteYearId=' + siteYearId;
        return this.http.post<number>(System.apiURL.Counselor + 'MassAddRequiredCourseRequests' + queryString, studentIds);
  }

}
